import {gql} from '@apollo/client';
import {useLazyQuery} from '@apollo/client/react';
import { fetchCurrentUser } from '../currentUserService';

const GET_CURRENT_USER_INFORMATION = gql`
    query GetCurrentUserInformation {
        currentUser {
            email
            personalEmail
            addressLine1
            phoneNumber
            addressLine2
            city
            countryCode
            entryDate
            leaveDate
            iban
            bicCode
            cooptedBy {
                cooptant {
                    firstname
                    lastname
                    uuid
                }
            }
            cooptantFor {
                coopted {
                    firstname
                    lastname
                    uuid
                }
                monthsDuration
                percentage
                startDate
            }
            consultantProfile {
                name
                uuid
                cooptationType
            }
            latestStatementMonth {
                commission
            }
            retributionModel {
                upToFiveConsultants
                upToTenConsultants
                moreThanTenConsultants
            }

            zipCode
            lastname
            firstname
            uuid
            company {
                uuid
            }
        }
    }
`;

const useCurrentUser = () => {

    const [getCurrentUserInfoQuery, { data: currentUserInfoData, loading: getCurrentUserInfoLoading, error: getCurrentUserInfoError }] = useLazyQuery(GET_CURRENT_USER_INFORMATION);

    const getCurrentUser = async () => {
        // Utilise le service partagé pour maintenir la cohérence
        return await fetchCurrentUser();
    };

    const getCurrentUserInformation = async () => {
        try {
            const result = await getCurrentUserInfoQuery();
            return { data: result.data?.currentUser || null, error: null };
        } catch (err) {
            return { data: null, error: err };
        }
    };

    const refetchCurrentUser = async () => {
        return await getCurrentUserInformation();
    };

    const loading = getCurrentUserInfoLoading;
    const error =  getCurrentUserInfoError;

    return {
        getCurrentUser,
        currentUserInformation: currentUserInfoData?.currentUser || null,
        getCurrentUserInformation,
        refetchCurrentUser,
        loading,
        error
    };
};

export default useCurrentUser;
